module.exports = __webpack_public_path__ + "img/calendar_color.a784fc3b.svg";